

import axios from 'axios'

const Collection = {

    async get(collectionId){
        const options = {
            url: `${window.ProveAnything.config.functionPath}/collection/${collectionId}`,
            baseURL: window.ProveAnything.config.functionUrl,
            method: "get",
            headers: {
              "Content-Type": "application/json"
            },
            responseType: "json",
          };
      
          try {
            const response = await axios(options);
            const json = response.data;
      
            return json;
          } catch (error) {
            return error
          }
    }
}

export default Collection;
